import jsPDF from 'jspdf';

export const generateOrderPDF = (order, isPreview = false) => {
  try {
    console.log('📄 Generating COD receipt for order:', order.orderNumber);
    
    const doc = new jsPDF();
    
    // ✅ Simple Header - Just "Receipt"
    doc.setFontSize(20);
    doc.setTextColor(40, 40, 40);
    doc.text('RECEIPT', 20, 25);
    
    // ✅ Order Information Box
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.rect(140, 15, 65, 25);
    
    doc.setFontSize(14);
    doc.setTextColor(40, 40, 40);
    doc.text(`Order #${order.orderNumber || 'N/A'}`, 145, 25);
    
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Date: ${order.date ? new Date(order.date).toLocaleDateString('en-GB') : 'N/A'}`, 145, 35);
    
    // ✅ Customer Details Section
    let yPosition = 50;
    
    doc.setFontSize(16);
    doc.setTextColor(40, 40, 40);
    doc.text('Customer Details', 20, yPosition);
    
    yPosition += 5;
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(20, yPosition, 190, yPosition);
    
    yPosition += 15;
    doc.setFontSize(11);
    
    // Customer details in a clean layout
    const customerDetails = [
      { label: 'Business Name:', value: order.customer?.businessName || 'N/A' },
      { label: 'Contact Person:', value: order.customer?.contactPerson || 'N/A' },
      { label: 'Phone:', value: order.customer?.phoneNumber || 'N/A' },
      { label: 'Email:', value: order.customer?.email || 'N/A' },
      { label: 'Address:', value: order.customer?.address || 'N/A' },
      { label: 'ABN:', value: order.customer?.abn || 'N/A' },
    ];
    
    customerDetails.forEach((detail) => {
      doc.setTextColor(100, 100, 100);
      doc.text(detail.label, 20, yPosition);
      doc.setTextColor(40, 40, 40);
      
      // Handle long text by splitting it
      const maxWidth = 120;
      const lines = doc.splitTextToSize(String(detail.value), maxWidth);
      doc.text(lines, 70, yPosition);
      
      yPosition += lines.length * 6 + 2;
    });
    
    // ✅ Order Details Section (Only PO Number and Comments)
    yPosition += 10;
    
    if (order.purchaseOrdeNo || order.comments) {
      doc.setFontSize(16);
      doc.setTextColor(40, 40, 40);
      doc.text('Order Details', 20, yPosition);
      
      yPosition += 5;
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 15;
      
      doc.setFontSize(11);
      
      if (order.purchaseOrdeNo) {
        doc.setTextColor(100, 100, 100);
        doc.text('Purchase Order No.:', 20, yPosition);
        doc.setTextColor(40, 40, 40);
        doc.text(String(order.purchaseOrdeNo), 70, yPosition);
        yPosition += 8;
      }
      
      if (order.comments) {
        doc.setTextColor(100, 100, 100);
        doc.text('Comments:', 20, yPosition);
        yPosition += 8;
        doc.setTextColor(40, 40, 40);
        const splitComments = doc.splitTextToSize(String(order.comments), 150);
        doc.text(splitComments, 20, yPosition);
        yPosition += splitComments.length * 6 + 10;
      }
    }
    
    // ✅ Products Section - Manual Table
    yPosition += 10;
    
    doc.setFontSize(16);
    doc.setTextColor(40, 40, 40);
    doc.text('Products', 20, yPosition);
    
    yPosition += 15;
    
    // ✅ Table Headers
    doc.setFontSize(10);
    doc.setFont(undefined, 'bold');
    doc.setFillColor(71, 125, 191);
    doc.rect(20, yPosition - 5, 170, 10, 'F');
    
    doc.setTextColor(255, 255, 255);
    doc.text('Product Name', 25, yPosition);
    doc.text('SKU', 90, yPosition);
    doc.text('Qty', 115, yPosition);
    doc.text('Unit Price', 135, yPosition);
    doc.text('Total', 165, yPosition);
    
    yPosition += 15;
    
    // ✅ Table Data
    doc.setFont(undefined, 'normal');
    doc.setTextColor(40, 40, 40);
    
    let grandTotal = 0;
    let rowColor = false;
    
    if (order.products && Array.isArray(order.products)) {
      order.products.forEach((item, index) => {
        const product = item.product || {};
        const quantity = item.quantity || 0;
        const unitPrice = item.price || product.price || 0;
        const total = quantity * unitPrice;
        grandTotal += total;
        
        // Alternating row colors
        if (rowColor) {
          doc.setFillColor(245, 245, 245);
          doc.rect(20, yPosition - 5, 170, 10, 'F');
        }
        rowColor = !rowColor;
        
        // Product data
        const productName = (product.productName || 'N/A').substring(0, 30);
        const sku = (product.sku || 'N/A').substring(0, 12);
        
        doc.text(productName, 25, yPosition);
        doc.text(sku, 90, yPosition);
        doc.text(String(quantity), 115, yPosition);
        doc.text(`$${unitPrice.toFixed(2)}`, 135, yPosition);
        doc.text(`$${total.toFixed(2)}`, 165, yPosition);
        
        yPosition += 10;
        
        // Check if we need a new page
        if (yPosition > 250) {
          doc.addPage();
          yPosition = 30;
        }
      });
    }
    
    // ✅ Total Section
    yPosition += 5;
    doc.setLineWidth(0.5);
    doc.line(20, yPosition, 190, yPosition);
    yPosition += 15;
    
    // Total row with highlight
    doc.setFont(undefined, 'bold');
    doc.setFillColor(230, 230, 230);
    doc.rect(20, yPosition - 5, 170, 12, 'F');
    
    doc.setTextColor(40, 40, 40);
    doc.setFontSize(12);
    doc.text('TOTAL:', 135, yPosition);
    doc.text(`$${grandTotal.toFixed(2)}`, 165, yPosition);
    
    // ✅ Simple Footer
    const pageHeight = doc.internal.pageSize.height;
    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.setFont(undefined, 'normal');
    
    // Footer line
    doc.setLineWidth(0.3);
    doc.line(20, pageHeight - 25, 190, pageHeight - 25);
    
    doc.text(`Generated on: ${new Date().toLocaleString('en-GB')}`, 20, pageHeight - 15);
    doc.text(`Page 1`, 170, pageHeight - 15);
    
    if (isPreview) {
      return doc;
    }
    
    // ✅ Save the PDF with safe filename
    const safeBusinessName = (order.customer?.businessName || 'Customer')
      .replace(/[^a-z0-9]/gi, '_')
      .substring(0, 20);
    const filename = `Receipt_${order.orderNumber}_${safeBusinessName}.pdf`;
    doc.save(filename);
    
    console.log('✅ Receipt generated successfully:', filename);
    return doc;
    
  } catch (error) {
    console.error('❌ Error in generateOrderPDF:', error);
    throw new Error(`PDF generation failed: ${error.message}`);
  }
};

export const generateBulkOrdersPDF = (orders) => {
  try {
    console.log('📄 Generating bulk receipts for', orders.length, 'orders');
    
    if (!orders || !Array.isArray(orders) || orders.length === 0) {
      throw new Error('No orders provided for bulk PDF generation');
    }
    
    const doc = new jsPDF();
    let isFirstOrder = true;
    
    // ✅ Generate individual receipts for each order on separate pages
    orders.forEach((order, index) => {
      // Add new page for each order (except the first one)
      if (!isFirstOrder) {
        doc.addPage();
      }
      isFirstOrder = false;
      
      // Use the same format as individual PDF generation
      // ✅ Simple Header - Just "Receipt"
      doc.setFontSize(20);
      doc.setTextColor(40, 40, 40);
      doc.text('RECEIPT', 20, 25);
      
      // ✅ Order Information Box
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.rect(140, 15, 65, 25);
      
      doc.setFontSize(14);
      doc.setTextColor(40, 40, 40);
      doc.text(`Order #${order.orderNumber || 'N/A'}`, 145, 25);
      
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text(`Date: ${order.date ? new Date(order.date).toLocaleDateString('en-GB') : 'N/A'}`, 145, 35);
      
      // ✅ Customer Details Section
      let yPosition = 50;
      
      doc.setFontSize(16);
      doc.setTextColor(40, 40, 40);
      doc.text('Customer Details', 20, yPosition);
      
      yPosition += 5;
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(20, yPosition, 190, yPosition);
      
      yPosition += 15;
      doc.setFontSize(11);
      
      // Customer details in a clean layout
      const customerDetails = [
        { label: 'Business Name:', value: order.customer?.businessName || 'N/A' },
        { label: 'Contact Person:', value: order.customer?.contactPerson || 'N/A' },
        { label: 'Phone:', value: order.customer?.phoneNumber || 'N/A' },
        { label: 'Email:', value: order.customer?.email || 'N/A' },
        { label: 'Address:', value: order.customer?.address || 'N/A' },
        { label: 'ABN:', value: order.customer?.abn || 'N/A' },
      ];
      
      customerDetails.forEach((detail) => {
        doc.setTextColor(100, 100, 100);
        doc.text(detail.label, 20, yPosition);
        doc.setTextColor(40, 40, 40);
        
        // Handle long text by splitting it
        const maxWidth = 120;
        const lines = doc.splitTextToSize(String(detail.value), maxWidth);
        doc.text(lines, 70, yPosition);
        
        yPosition += lines.length * 6 + 2;
      });
      
      // ✅ Order Details Section (Only PO Number and Comments)
      yPosition += 10;
      
      if (order.purchaseOrdeNo || order.comments) {
        doc.setFontSize(16);
        doc.setTextColor(40, 40, 40);
        doc.text('Order Details', 20, yPosition);
        
        yPosition += 5;
        doc.line(20, yPosition, 190, yPosition);
        yPosition += 15;
        
        doc.setFontSize(11);
        
        if (order.purchaseOrdeNo) {
          doc.setTextColor(100, 100, 100);
          doc.text('Purchase Order No.:', 20, yPosition);
          doc.setTextColor(40, 40, 40);
          doc.text(String(order.purchaseOrdeNo), 70, yPosition);
          yPosition += 8;
        }
        
        if (order.comments) {
          doc.setTextColor(100, 100, 100);
          doc.text('Comments:', 20, yPosition);
          yPosition += 8;
          doc.setTextColor(40, 40, 40);
          const splitComments = doc.splitTextToSize(String(order.comments), 150);
          doc.text(splitComments, 20, yPosition);
          yPosition += splitComments.length * 6 + 10;
        }
      }
      
      // ✅ Products Section - Manual Table
      yPosition += 10;
      
      doc.setFontSize(16);
      doc.setTextColor(40, 40, 40);
      doc.text('Products', 20, yPosition);
      
      yPosition += 15;
      
      // ✅ Table Headers
      doc.setFontSize(10);
      doc.setFont(undefined, 'bold');
      doc.setFillColor(71, 125, 191);
      doc.rect(20, yPosition - 5, 170, 10, 'F');
      
      doc.setTextColor(255, 255, 255);
      doc.text('Product Name', 25, yPosition);
      doc.text('SKU', 90, yPosition);
      doc.text('Qty', 115, yPosition);
      doc.text('Unit Price', 135, yPosition);
      doc.text('Total', 165, yPosition);
      
      yPosition += 15;
      
      // ✅ Table Data
      doc.setFont(undefined, 'normal');
      doc.setTextColor(40, 40, 40);
      
      let grandTotal = 0;
      let rowColor = false;
      
      if (order.products && Array.isArray(order.products)) {
        order.products.forEach((item, itemIndex) => {
          const product = item.product || {};
          const quantity = item.quantity || 0;
          const unitPrice = item.price || product.price || 0;
          const total = quantity * unitPrice;
          grandTotal += total;
          
          // Alternating row colors
          if (rowColor) {
            doc.setFillColor(245, 245, 245);
            doc.rect(20, yPosition - 5, 170, 10, 'F');
          }
          rowColor = !rowColor;
          
          // Product data
          const productName = (product.productName || 'N/A').substring(0, 30);
          const sku = (product.sku || 'N/A').substring(0, 12);
          
          doc.text(productName, 25, yPosition);
          doc.text(sku, 90, yPosition);
          doc.text(String(quantity), 115, yPosition);
          doc.text(`$${unitPrice.toFixed(2)}`, 135, yPosition);
          doc.text(`$${total.toFixed(2)}`, 165, yPosition);
          
          yPosition += 10;
        });
      }
      
      // ✅ Total Section
      yPosition += 5;
      doc.setLineWidth(0.5);
      doc.line(20, yPosition, 190, yPosition);
      yPosition += 15;
      
      // Total row with highlight
      doc.setFont(undefined, 'bold');
      doc.setFillColor(230, 230, 230);
      doc.rect(20, yPosition - 5, 170, 12, 'F');
      
      doc.setTextColor(40, 40, 40);
      doc.setFontSize(12);
      doc.text('TOTAL:', 135, yPosition);
      doc.text(`$${grandTotal.toFixed(2)}`, 165, yPosition);
      
      // ✅ Simple Footer
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.setFont(undefined, 'normal');
      
      // Footer line
      doc.setLineWidth(0.3);
      doc.line(20, pageHeight - 25, 190, pageHeight - 25);
      
      doc.text(`Generated on: ${new Date().toLocaleString('en-GB')}`, 20, pageHeight - 15);
      doc.text(`Page ${index + 1} of ${orders.length}`, 170, pageHeight - 15);
    });
    
    // ✅ Save the bulk PDF with safe filename
    const dateStr = new Date().toISOString().split('T')[0];
    const filename = `Bulk_Receipts_${orders.length}_Orders_${dateStr}.pdf`;
    doc.save(filename);
    
    console.log('✅ Bulk receipts generated successfully:', filename);
    return doc;
    
  } catch (error) {
    console.error('❌ Error in generateBulkOrdersPDF:', error);
    throw new Error(`Bulk PDF generation failed: ${error.message}`);
  }
};